<div
  [attr.layout-align-items-center]="centered() && !stage ? '' : null"
  [attr.layout-align-items-start]="!centered() ? '' : null"
  [class.hasStage]="stage"
  [rtTooltip]="$safeNavigationMigration(offer()?.title)"
  [rtTooltipEnabled]="!!offer()"
  [rtTooltipPosition]="'below'"
  layout-full-height
  layout-horizontal
>
  @if (tooltip()) {
    @if (ratingKey) {
      <rt-icon
        [name]="ratingThumbOptions[ratingKey].icon"
        [rtTooltip]="getRatingTranslation(ratingKey)"
        [rtTooltipPosition]="'right'"
        [colorToken]="colorize() ? ratingThumbOptions[ratingKey].color : undefined"
        [size]="size()"
      />
    }
  }

  @if (!tooltip()) {
    @if (ratingKey) {
      <rt-icon
        [name]="ratingThumbOptions[ratingKey].icon"
        [colorToken]="colorize() ? ratingThumbOptions[ratingKey].color : undefined"
        [size]="size()"
      />
    }
  }
  <div class="text-wrap" min-width-0>
    @if (hasVariant('hasLabel')) {
      <div class="rating">
        <rt-truncate>
          {{ getRatingTranslation(ratingKey) }}
        </rt-truncate>
      </div>
    }
    @if (stage) {
      <div class="stage">
        <rt-truncate>
          <em>{{ stage }}</em>
        </rt-truncate>
      </div>
    }
  </div>
</div>
